export default {
      id: "icon-email-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-email",
      toString: function () {
        return this.url;
      }
    }